module.exports = __webpack_public_path__ + "media/images/registration/dod_contractor_user-270f06ead5b1b27d7289a7c2eaa13717.png";